import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatCommonModule } from "@angular/material/core";
import { CommonModule } from "@angular/common";
import { NgxMaskDirective, provideNgxMask } from "ngx-mask";

import { InputFormFieldComponent } from "./input-form-field/input-form-field.component";
import { AutoCompleteFormFieldComponent } from "./auto-complete-form-field/auto-complete-form-field.component";
import { NumberFormFieldComponent } from "./number-form-field/number-form-field.component";
import { TextAreaFormFieldComponent } from "./text-area-form-field/text-area-form-field.component";
import { MaskedFormFieldComponent } from "./masked-form-field/masked-form-field.component";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { ExpiryMonthFormFieldComponent } from "./expiry-month-form-field/expiry-month-form-field.component";
import { SelectFormFieldComponent } from "./select-form-field/select-form-field.component";
import { TryCatchMaterialExtensionModule } from "@dodo/material-extension";
import { MatIconModule } from "@angular/material/icon";
import { CheckBoxComponent } from "./check-box/check-box.component";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { InputFieldComponent } from "./input-field/input-field.component";
import { MomentFieldComponent } from "./moment-field/moment-field.component";
import { MaskedFieldComponent } from "./masked-field/masked-field.component";
import { AddressFieldComponent } from "./address-field/address-field.component";
import { AutoCompleteFieldComponent } from "./autocomplete-field/autocomplete-field.component";
import { MaterialModule } from "_libs/material-module/material.module";
import { DodoDirectives } from "@dodo/directives/directives.module";
import { DodoMatComponentsCommonModule } from "_libs/dodo-mat-components/dodo-mat-components-common.module";
import { MobileToolTipComponent } from "@dodo/mobile-tooltip/mobile-tooltip.component";

@NgModule({
	imports: [
		DodoDirectives,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatCommonModule,
		MaterialModule,
		MatInputModule,
		MatDatepickerModule,
		MatFormFieldModule,
		MatMomentDateModule,
		MatProgressSpinnerModule,
		MatSelectModule,
		NgxMaskDirective,
		TryCatchMaterialExtensionModule,
		MatIconModule,
		MatCheckboxModule,
		DodoMatComponentsCommonModule,
		MobileToolTipComponent
	],
	declarations: [
		InputFieldComponent,
		InputFormFieldComponent,
		AutoCompleteFormFieldComponent, // Todo to remove after test
		AutoCompleteFieldComponent,
		NumberFormFieldComponent,
		TextAreaFormFieldComponent,
		MaskedFormFieldComponent, // TODO to remove
		MaskedFieldComponent,
		MomentFieldComponent,
		AddressFieldComponent, // Neww address component common for all
		ExpiryMonthFormFieldComponent,
		SelectFormFieldComponent,
		CheckBoxComponent,
	],
	exports: [
		InputFieldComponent,
		InputFormFieldComponent,
		AutoCompleteFormFieldComponent, // TODO to remove
		AutoCompleteFieldComponent,
		NumberFormFieldComponent,
		TextAreaFormFieldComponent,
		MaskedFormFieldComponent, // TODO to remove
		MaskedFieldComponent,
		MomentFieldComponent,
		AddressFieldComponent,
		ExpiryMonthFormFieldComponent,
		SelectFormFieldComponent,
		CheckBoxComponent,
	],
	providers: [provideNgxMask()],
})
export class TryCatchMaterialFormsModule {}
